// device list
export const DEVICE_LIST = ['pc', 'tablet', 'mobile'] as const;

// Media Queries
export const TABLET_MAX_WIDTH = 1100;
export const MOBILE_MAX_WIDTH = 576;
export const MINIMUM_MOBILE_WIDTH = 320;
export const BREAK_POINT_TABLE = { 'mobile': `${MOBILE_MAX_WIDTH}px`, 'tablet': `${TABLET_MAX_WIDTH}px` };

// レスポンシブ対応のためのclamp用
export const PC_CLAMP_BASIS_WIDTH = TABLET_MAX_WIDTH + 1;
export const TABLET_CLAMP_BASIS_WIDTH = MOBILE_MAX_WIDTH + 1;
export const MOBILE_CLAMP_BASIS_WIDTH = MINIMUM_MOBILE_WIDTH;

// デザインのモバイル幅
export const DESIGN_MOBILE_WIDTH = 375;

// 地域の配列
export const REGIONS = [
  { id: 1, name: '北海道・東北' },
  { id: 2, name: '関東' },
  { id: 3, name: '北陸・甲信越' },
  { id: 4, name: '東海' },
  { id: 5, name: '関西' },
  { id: 6, name: '中国' },
  { id: 7, name: '四国' },
  { id: 8, name: '九州・沖縄' },
] as const;

// 都道府県の配列
export const PREFECTURES = [
  { id: 1, name: '北海道', regionId: 1, regionOrder: 1 },
  { id: 2, name: '青森県', regionId: 1, regionOrder: 4 },
  { id: 3, name: '岩手県', regionId: 1, regionOrder: 5 },
  { id: 4, name: '宮城県', regionId: 1, regionOrder: 2 },
  { id: 5, name: '秋田県', regionId: 1, regionOrder: 6 },
  { id: 6, name: '山形県', regionId: 1, regionOrder: 7 },
  { id: 7, name: '福島県', regionId: 1, regionOrder: 3 },
  { id: 8, name: '茨城県', regionId: 2, regionOrder: 5 },
  { id: 9, name: '栃木県', regionId: 2, regionOrder: 7 },
  { id: 10, name: '群馬県', regionId: 2, regionOrder: 6 },
  { id: 11, name: '埼玉県', regionId: 2, regionOrder: 2 },
  { id: 12, name: '千葉県', regionId: 2, regionOrder: 4 },
  { id: 13, name: '東京都', regionId: 2, regionOrder: 1 },
  { id: 14, name: '神奈川県', regionId: 2, regionOrder: 3 },
  { id: 15, name: '新潟県', regionId: 3, regionOrder: 1 },
  { id: 16, name: '富山県', regionId: 3, regionOrder: 4 },
  { id: 17, name: '石川県', regionId: 3, regionOrder: 3 },
  { id: 18, name: '福井県', regionId: 3, regionOrder: 6 },
  { id: 19, name: '山梨県', regionId: 3, regionOrder: 5 },
  { id: 20, name: '長野県', regionId: 3, regionOrder: 2 },
  { id: 21, name: '岐阜県', regionId: 4, regionOrder: 3 },
  { id: 22, name: '静岡県', regionId: 4, regionOrder: 2 },
  { id: 23, name: '愛知県', regionId: 4, regionOrder: 1 },
  { id: 24, name: '三重県', regionId: 4, regionOrder: 4 },
  { id: 25, name: '滋賀県', regionId: 5, regionOrder: 4 },
  { id: 26, name: '京都府', regionId: 5, regionOrder: 3 },
  { id: 27, name: '大阪府', regionId: 5, regionOrder: 1 },
  { id: 28, name: '兵庫県', regionId: 5, regionOrder: 2 },
  { id: 29, name: '奈良県', regionId: 5, regionOrder: 5 },
  { id: 30, name: '和歌山県', regionId: 5, regionOrder: 6 },
  { id: 31, name: '鳥取県', regionId: 6, regionOrder: 5 },
  { id: 32, name: '島根県', regionId: 6, regionOrder: 4 },
  { id: 33, name: '岡山県', regionId: 6, regionOrder: 2 },
  { id: 34, name: '広島県', regionId: 6, regionOrder: 1 },
  { id: 35, name: '山口県', regionId: 6, regionOrder: 3 },
  { id: 36, name: '徳島県', regionId: 7, regionOrder: 3 },
  { id: 37, name: '香川県', regionId: 7, regionOrder: 2 },
  { id: 38, name: '愛媛県', regionId: 7, regionOrder: 1 },
  { id: 39, name: '高知県', regionId: 7, regionOrder: 4 },
  { id: 40, name: '福岡県', regionId: 8, regionOrder: 1 },
  { id: 41, name: '佐賀県', regionId: 8, regionOrder: 8 },
  { id: 42, name: '長崎県', regionId: 8, regionOrder: 4 },
  { id: 43, name: '熊本県', regionId: 8, regionOrder: 3 },
  { id: 44, name: '大分県', regionId: 8, regionOrder: 6 },
  { id: 45, name: '宮崎県', regionId: 8, regionOrder: 5 },
  { id: 46, name: '鹿児島県', regionId: 8, regionOrder: 2 },
  { id: 47, name: '沖縄県', regionId: 8, regionOrder: 7 },
] as const;
